var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomePenceReportActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=IncomePenceReport, Property 2=Active"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M12 33.7703H8C7.44772 33.7703 7 34.218 7 34.7703V42.5C7 43.0523 7.44772 43.5 8 43.5H12C12.5523 43.5 13 43.0523 13 42.5V34.7703C13 34.218 12.5523 33.7703 12 33.7703Z",
    fill: "#E0E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M22 28.9054H18C17.4477 28.9054 17 29.3531 17 29.9054V42.5C17 43.0523 17.4477 43.5 18 43.5H22C22.5523 43.5 23 43.0523 23 42.5V29.9054C23 29.3531 22.5523 28.9054 22 28.9054Z",
    fill: "#E0E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 22.0946H32C32.5523 22.0946 33 22.5423 33 23.0946V42.5C33 43.0523 32.5523 43.5 32 43.5H28C27.4477 43.5 27 43.0523 27 42.5V23.0946C27 22.5423 27.4477 22.0946 28 22.0946ZM16 7C20.9706 7 25 11.0294 25 16C25 20.9706 20.9706 25 16 25C11.0294 25 7 20.9706 7 16C7 11.0294 11.0294 7 16 7ZM16 9C12.134 9 9 12.134 9 16C9 19.866 12.134 23 16 23C19.866 23 23 19.866 23 16C23 12.134 19.866 9 16 9ZM14.368 11.5L16.0576 14.8051L17.7088 11.5H20L17.7088 15.2119H19.296V16.5212H17.0048V17.3475H19.296V18.6568H17.0048V20.5H14.9824V18.6568H12.704V17.3475H14.9824V16.5212H12.704V15.2119H14.3296L12 11.5H14.368Z",
    fill: "#0075E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    d: "M42 7.5H38C37.4477 7.5 37 7.94772 37 8.5V42.5C37 43.0523 37.4477 43.5 38 43.5H42C42.5523 43.5 43 43.0523 43 42.5V8.5C43 7.94772 42.5523 7.5 42 7.5Z",
    fill: "#E0E4E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomePenceReportActive);
export default __webpack_public_path__ + "static/media/incomePenceReport-active.8c9960b613eecc065ed922803b1ea38e.svg";
export { ForwardRef as ReactComponent };